import React from 'react'
import t from '../../translations/i18n'

export default function Header() {
  return (
    <>
      <header id="header" className="fixed-top d-flex align-items-center">
        <div className="container d-flex align-items-center justify-content-between">
          <div className="logo">
            <a href="/" className="d-flex align-items-center">
              <img src="/assets/img/logo.png" alt="SIGMATEC" />
            </a>
          </div>
          <nav id="navbar" className="navbar">
            <ul>
              <li>
                <a
                  className="nav-link scrollto active"
                  href={t('header.menu_init_ref')}
                >
                  {t('header.menu_init')}
                </a>
              </li>
              <li>
                <a className="nav-link scrollto" href={t('header.menu_us_ref')}>
                  {t('header.menu_us')}
                </a>
              </li>
              <li>
                <a
                  className="nav-link scrollto"
                  href={t('header.menu_services_ref')}
                >
                  {t('header.menu_services')}
                </a>
              </li>
              <li>
                <a
                  className="nav-link scrollto"
                  href={t('header.menu_products_ref')}
                >
                  {t('header.menu_products')}
                </a>
              </li>
              <li>
                <a
                  className="nav-link scrollto"
                  href={t('header.menu_questions_ref')}
                >
                  {t('header.menu_questions')}
                </a>
              </li>
              <li>
                <a
                  className="nav-link scrollto"
                  href={t('header.menu_contact_ref')}
                >
                  {t('header.menu_contact')}
                </a>
              </li>
            </ul>
            <i className="bi bi-list mobile-nav-toggle"></i>
          </nav>
        </div>
      </header>
    </>
  )
}
